import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ClipboardCheck, Monitor } from 'lucide-react';
import { Logo } from '../../components/Logo';
import { UserMenu } from '../../components/UserMenu';
import { paths } from '../../routes/paths';

export function MobileTaskUnavailableView() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2 min-w-0">
            <ClipboardCheck className="h-7 w-7 text-primary shrink-0" />
            <Logo className="text-xl font-bold text-gray-900 truncate" />
          </div>
          <UserMenu />
        </div>
      </header>

      <main className="px-5 py-8">
        <div className="rounded-md border border-gray-200 bg-white p-5">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 text-primary">
            <Monitor className="h-7 w-7" />
          </div>
          <h1 className="text-xl font-semibold text-gray-900">Desktop required</h1>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            Tasks and reviews can only be completed on desktop devices. Use a larger screen to work,
            review, approve, or request changes.
          </p>
          <Link
            to={paths.queue()}
            className="mt-5 inline-flex min-h-[44px] items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-hover"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to queue
          </Link>
        </div>
      </main>
    </div>
  );
}
